import React from 'react'
// import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import PressItem from '../press-item'
import { Container } from './index.styled'

const PressList = ({ data }) => {
  return (
    <Container>
      {data.map((item) => (
        <PressItem key={`press-item-${item.Slug}`} {...item} isShort />
      ))}
    </Container>
  )
}

export default PressList
